import { request } from './client';

export function getTournaments() {
  return request('/api/tournaments');
}

export function getTournament(tournamentId) {
  return request(`/api/tournaments/${tournamentId}`);
}
